module.exports = {
  updateGrid: function(xhr) {
    const $searchResults = $('#gtm-viewMore-products');

    if ($searchResults.length) {
      const updatedProducts = $('#gtm-viewMore-products').attr('data-search-products');
      $('#gtm-pdp-products').attr('data-gtm-products', updatedProducts);

      //Call Impressions
      $('body').trigger('gtm:eec:productImpressions', updatedProducts);

      //Call product list view GA4
      $('body').trigger('gtm:ga4:viewItemList', updatedProducts);

      //Removed dynamic search results data
      $('#gtm-viewMore-products').remove();
    }
  }
}